import VehicleDetailView from './vehicle-detail-view.vue';
import VehicleEventsView from './vehicle-events-view.vue';
import VehiclePoHistoryView from './vehicle-po-history-view.vue';
import VehicleRoHistoryView from './vehicle-ro-history-view.vue';
import VehicleWarrantyView from './vehicle-warranty-view.vue';

export default [
	{
		path: 'vehicle/:id',
		props: route => ({ id: parseInt(route.params.id) }),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "vehicle" */ '@/sections/sales/vehicle/vehicle-page.vue'
			),
		children: [
			{
				path: '',
				name: 'vehicle-detail',
				component: VehicleDetailView,
				props: route => ({ id: parseInt(route.params.id) })
			},
			{
				path: 'events',
				name: 'vehicle-events',
				component: VehicleEventsView,
				props: route => ({ id: parseInt(route.params.id) })
			},
			{
				path: 'po-history',
				name: 'vehicle-po-history',
				component: VehiclePoHistoryView,
				props: route => ({ id: parseInt(route.params.id) })
			},
			{
				path: 'ro-history',
				name: 'vehicle-ro-history',
				component: VehicleRoHistoryView,
				props: route => ({ id: parseInt(route.params.id) })
			},
			{
				path: 'warranty',
				name: 'vehicle-warranty',
				component: VehicleWarrantyView,
				props: route => ({ id: parseInt(route.params.id) })
			}
		]
	}
];
